import { ConfigProvider } from "antd";
import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { useThemeStore, THEMES_MAP } from "../stores/ThemeStore.ts";
import { getLocale } from "@/helpers/localeHelper.ts";

function AntdThemeConfigProvider({ children }: PropsWithChildren) {
  const { getTheme } = useThemeStore();
  const currentThemeKey = getTheme();
  const theme = THEMES_MAP[currentThemeKey];

  // Statische APIs (notification.success, Modal.*, …) rendern außerhalb dieses
  // Providers und lesen nur globalConfig().theme — ohne Sync bleiben sie beim Default.
  useEffect(() => {
    ConfigProvider.config({ theme });
  }, [theme]);

  document.documentElement.setAttribute("theme", currentThemeKey);
  return (
    <ConfigProvider theme={theme} locale={getLocale().locale}>
      {children}
    </ConfigProvider>
  );
}

export { AntdThemeConfigProvider };
